<div role="dialog" aria-labelledby="modalConfirmation" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalConfirmation">
          Confirmação
          <br>
          <span class="text-muted fw-normal font-14">{{ data }}</span>
        </h4>
        <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-light"
          (click)="onNoClick()">
          Cancelar
        </button>
        <button 
          class="btn btn-primary"
          [mat-dialog-close]="true" cdkFocusInitial
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</div>